// src/components/layout.js
import React from "react";
import Header from "./header";
import Footer from "./footer";

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen w-full overflow-x-hidden">
      <Header />
      {children}
      <Footer />
    </div>
  );
};

export default Layout;
